import { ICampaign, ICampaignConfig, ICampaignInit } from 'types/campaign';
import { getCampaignConfig, getCampaignInfo, getPromotionInfo } from 'services/campaign/index';

export interface IRes {
    campaign?: ICampaign; // 用于外部展示
    promotion: ICampaign[];
    fullDiscount?: ICampaign;
    platformFullDiscount?: ICampaign;
}

export const differMultiCampaign = (multiCampaign: ICampaignInit[]) => {
    const res: IRes = {
        campaign: undefined,
        promotion: [],
        fullDiscount: undefined,
        platformFullDiscount: undefined
    };
    if (!multiCampaign || multiCampaign.length === 0) return res;
    const campaignInfo = getCampaignInfo(multiCampaign);
    const campaignConfig = getCampaignConfig(campaignInfo);
    // 外部展示的一个活动信息
    if (campaignConfig) {
        res.campaign = { ...campaignConfig };
    }

    // 获取促销活动
    const promotionInfo = getPromotionInfo(multiCampaign);
    let promotionConfig: ICampaign[] = [];
    promotionInfo.forEach((item) => {
        const config = getCampaignConfig(item);
        if (config !== null) {
            promotionConfig.push(config);
        }
    });
    if (promotionConfig.length > 0) {
        res.promotion = promotionConfig;
        // 满减活动信息
        promotionConfig.forEach((item) => {
            if (item && item.stype === 100) {
                // 店铺满减
                res.fullDiscount = item;
            } else if (item && item.stype === 110) {
                res.platformFullDiscount = item;
            }
        });
    }
    return res;
};
